import { AwarenessItemProps, GeneralAwarenessProps } from "../properties/assessment";
import { Box, Grid, Typography, Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CircleIcon from '@mui/icons-material/Circle';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const AwarenessItem: React.FC<AwarenessItemProps> = ({ count, label, color, icon }) => {
    return (
      <Grid item xs={2} container alignItems="center" justifyContent="center">
        <Tooltip title={label} arrow>
          <Box
            sx={{
              width: 40,
              height: 40,
              backgroundColor: color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              color: 'white',
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.8,
              },
            }}
          >
            {icon}
          </Box>
        </Tooltip>
        <Typography variant="caption" sx={{ fontWeight: 'bold', marginLeft: 1 }}>
          {count}
        </Typography>
      </Grid>
    );
  };
  
  export const GeneralAwareness: React.FC<GeneralAwarenessProps> = ({ questions, questionStates }) => {
    const answeredCount = questionStates.filter(state => state.selectedOption !== null).length;
    const notAnsweredCount = questionStates.filter(state => state.selectedOption === null && state.visited).length;
    const notVisitedCount = questionStates.filter(state => !state.visited).length;
    const markedForReviewCount = questionStates.filter(state => state.markedForReview && state.selectedOption === null).length;
  
    const answeredAndMarkedCount = questionStates.filter(state => state.selectedOption !== null && state.markedForReview).length;
  
    return (
      <>
        <Box p={2} sx={{ backgroundColor: '#f7f7f7', borderRadius: 2 }}>
          <Grid container spacing={2} mx={2}>
            <AwarenessItem
              count={answeredCount}
              label="Answered"
              color="green"
              icon={<CheckCircleIcon />}
            />
            <AwarenessItem
              count={notAnsweredCount}
              label="Not Answered"
              color="red"
              icon={<HighlightOffIcon />}
            />
            <AwarenessItem
              count={notVisitedCount}
              label="Not Visited"
              color="purple"
              icon={<CircleIcon />}
            />
            <AwarenessItem
              count={markedForReviewCount}
              label="Marked for Review"
              color="orange"
              icon={<QuestionMarkIcon />}
            />
            <AwarenessItem
              count={answeredAndMarkedCount}
              label="Answered & Marked for Review"
              color="darkorchid"
              icon={<RadioButtonUncheckedIcon />}
            />
          </Grid>
        </Box>
      </>
    );
  };
  
  